import { render, staticRenderFns } from "./classTable.vue?vue&type=template&id=1a961b12&scoped=true&"
import script from "./classTable.vue?vue&type=script&lang=js&"
export * from "./classTable.vue?vue&type=script&lang=js&"
import style0 from "./classTable.vue?vue&type=style&index=0&id=1a961b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a961b12",
  null
  
)

component.options.__file = "classTable.vue"
export default component.exports